const changingPageWithClick = (friendPerson,platform,action,friendName) => {
  friendPerson.map(
    (friend) =>
      (window.location.href = `/${platform}/${action}/${friendName}`),
  );
};

export {changingPageWithClick};